import type { EntityName, EntitySecurity, FeatureName } from '../../common/auth/Security';
import { SECURITY_ACTIONS, useSecurity } from '../../common/auth/Security';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import { FEATURE_CONSTANTS } from '../../common/constants/featureConstants';

/**
 * Shared production add/edit/delete gates for editor and details surfaces.
 *
 * Params are flattened so call sites do not need to memoize a params object.
 */
export function useProductionSecurity(
    featureName: FeatureName = FEATURE_CONSTANTS.production,
    entityName: EntityName = ENTITY_CONSTANTS.production,
    entitySecurity?: EntitySecurity
) {
    const { allowed: canAdd } = useSecurity(SECURITY_ACTIONS.EDIT, {
        featureName
    });
    const {
        allowed: [canEdit, canDelete]
    } = useSecurity([SECURITY_ACTIONS.EDIT, SECURITY_ACTIONS.DELETE], {
        featureName,
        entityName,
        entitySecurity
    });

    return {
        canAdd,
        canEdit,
        canDelete
    };
}
